/**
 * Template IDs — only two templates currently exist.
 */
export const TEMPLATE_ID = {
  BASE: 'base-template-1',
  SLIDES: 'slides-template-1',
} as const;

/**
 * Select the right template based on pre-flight tags.
 * Only use slides template when "presentation" is the PRIMARY tag (first in array).
 * When user selects a category (e.g., Animation), their tag is prepended first,
 * so AI-classified "presentation" at index 1+ should NOT override user intent.
 */
export function getTemplateIdForTags(tags?: string[]): string {
  if (tags?.[0] === 'presentation') {
    return TEMPLATE_ID.SLIDES;
  }
  return TEMPLATE_ID.BASE;
}
